
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse/stocks",
      function () {
        return require("private-next-pages/browse/stocks/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse/stocks"])
      });
    }
  